import { useSelector } from 'react-redux';
import { selectors } from 'darwin_core';

import { geolocationTileState } from './tileState.js';
import { GeolocationIcon } from '../components/icons.jsx';

// The Property geolocation tile — the app's geolocation Tile (Property.js) in the
// same card as the zone tiles: the geolocation glyph, a small Home / Away /
// Disabled line, the property's name, and the accent border while someone is home.
// There is no big state. Shown only for Halo classic homes; PropertyScreen applies
// that rule (the app's: neither Halo Air nor a Logic device).
//
// Home / Away is read exactly as the app reads it — darwin_core's
// geolocationHomeMode: 'disabled' unless geolocation is enabled AND at least one
// phone is registered; 'home' while any registered phone is at home (in the home
// zone, or between the zones having just left it); otherwise 'away'.
//
// Where the app's tile opens the Geolocation menu — a phone-only setup wizard
// (location permission, registered phones, home location, simple schedule,
// enable / disable, away temperature) — the web has nothing to act on, since the
// phones themselves drive geolocation. So this is a status-only card, not a link:
// still perceivable, but not a tab stop. Like the app, a Disabled tile is not
// dimmed — the small line carries the state.
export default function GeolocationTile({ homeId }) {
  // Select the mode string, not the selector's result object (a fresh object per
  // call would re-render on every store change).
  const mode = useSelector(
    (s) => selectors.geolocationHomeMode(s, homeId).mode,
  );
  const name = useSelector((s) => selectors.getHomeFriendlyName(s, homeId));
  const { smallState, active } = geolocationTileState(mode);

  const className =
    'zone-tile-card zone-tile-card--static' +
    (active ? ' zone-tile-card--active' : '');

  // As on the zone tiles, the label read by assistive tech leads with the name,
  // then what the tile is, then the state.
  const label = `${name}, Geolocation, ${smallState}`;

  return (
    <div className={className} role="group" aria-label={label}>
      <div className="zone-tile-card__top">
        <span className="zone-tile-card__icon" aria-hidden="true">
          <GeolocationIcon />
        </span>
      </div>
      <div className="zone-tile-card__bottom">
        <span className="zone-tile-card__text">
          <span className="zone-tile-card__small">{smallState}</span>
          <span className="zone-tile-card__name">{name}</span>
        </span>
      </div>
    </div>
  );
}
